<template>
  <div class="main-content">
    <div class="clear_big"/>
    <div class="clear_big"/>
    <div class="clear_big"/>
    <section class="container section">
      <h2> Come contattarci </h2>
      <p>Contattaci per qualsiasi informazione e risponderemo alle tue richieste!</p>
      <div class="clear_big"/>
      <div class="clear_big"/>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12891.791483704583!2d12.426738633753267!3d45.703839200894414!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xedc44a5b9e089e0!2sArtfiber!5e0!3m2!1sit!2sit!4v1455979379355"
            width="100%"
            height="400"
            frameborder="0"
            style="border: solid 1px #cccccc;"
            allowfullscreen>
          </iframe>
        </div>
        <div class="clear_big"/>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <table class="table contact_table">
            <thead>
              <tr>
                <th class="contact_title"> Sede, orari e recapiti </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td> via Postumia Est, 100 </td>
              </tr>
              <tr>
                <td> 31042 - Fagarè della Battaglia (TV) - Italia </td>
              </tr>
              <tr><td></td></tr>
              <tr><td></td></tr>
              <tr><td></td></tr>
              <tr>
                <td> Tel: 0422 890276  </td>
              </tr>
              <tr>
                <td> Fax: 0422 890065 </td>
              </tr>
              <tr>
                <td> Damiano: 340 8506032 </td>
              </tr>
              <tr>
                <td> Matteo: 347 9208117 </td>
              </tr>
              <tr>
                <td> Mail: info@artfiber.it </td>
              </tr>
              <tr><td></td></tr>
              <tr><td></td></tr>
              <tr><td></td></tr>
              <tr>
                <td> dal Lunedì al Venerdì: 7.30 - 12.00 e 13.00 - 16.30 </td>
              </tr>
              <tr>
                <td> il Sabato: 8.00 - 12.00 </td>
              </tr>
              <tr><td></td></tr>
              <tr><td></td></tr>
              <tr><td></td></tr>
              <tr>
                <td> * Per appuntamenti fuori orario lavorativo, chiediamo cortesemente di contattare anticipatamente via mail o telefono. </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="clear_big"></div>
        <div class="clear_big"></div>
      </div>
    </section>
  </div>
</template>
<script>
import WorkInProgress from '@/components/WorkInProgress'
export default {
  name: 'contacts',
  components: {
    WorkInProgress
  },
}
</script>

<style scoped>
.contact_title {
  font-size: 18px;
}
.contact_table {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.contact_table tbody tr td,
.contact_table thead tr th {
  height: 100%;
  padding: 4px;
  border: none;
}
</style>